import { useLayoutEffect, useState } from "react"
import { BodyContainer } from "./styles"
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg'
import { useTranslation } from "react-i18next"

const Body = ({ children }) => {

  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const limit = 160
  const isExceedLimit = children.length > limit

  const currentLength = isOpen ? children.length : limit

  const body = children.slice(0, currentLength).trim()

  const handleOpen = () => setIsOpen(prev => !prev)

  useLayoutEffect(() => {
    setIsOpen(false)
  }, [children])

  return (
    <BodyContainer>
      {body}
      {isExceedLimit && (
        <>
          { isOpen ? ' ' : '... '}
          <button onClick={handleOpen}>
            { isOpen ? t('showLess') : t('showMore')}
            <ChevronDown
              height={12}
              width={12}
              transform={isOpen ? 'rotate(180)' : 'rotate(0)'}
            />
          </button>
        </>
      )}
    </BodyContainer>
  )
}

export default Body